import React from "react";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ImageElement } from "../../../components";

function MainFooter() {
  
  return (
    <footer className="footer">
        <div className="footer_top  position-relative">
            <div className="container">
                <div className="wrap mx-auto position-relative">
                    <h2 className="font-md text-white ">Check out our mobile app & experience the <span className="position-relative">fastest</span> home services</h2>
                    <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                        <Link to="/" className="me-2"> <ImageElement className="img-fluid" source="google-play.svg" alt="Google-play"/></Link>
                        <Link to="/"> <ImageElement source="app-store.svg" className="img-fluid" alt="App-store" /> </Link>
                    </div>
                    <ImageElement source="footer-img.png" className="wrap_img" alt="footer-img" />
                </div>
            </div>
        </div>
        <div className="footer_main">
            <div className="footer_main_top">
                <div className="container">
                    <div className="d-flex justify-content-between flex-wrap">
                        <div className="footer_main_cstm text-center text-sm-start">
                            <div className="ftLftInfo">
                                <Link to="/home"><ImageElement source="logo-white.svg" alt="logo" /></Link>
                                <p className="text-white">Need help finding a Professional?</p>
                                <ul className="list-unstyled mb-0">
                                    <li><Link to="/" ><em className="gg-message"></em> contact@gghs.com</Link></li>
                                    <li><Link to="/" ><em className="gg-Calling"></em> 7676-000-100</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer_main_cstm">
                            <div className="ftMenu">
                                <h3 className="font-md text-white">General Links</h3>
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <Link to="/aboutus">About Us</Link>
                                    </li>
                                    <li>
                                        <Link to="/howitworks">How it Works</Link>
                                    </li>
                                    <li>
                                        <Link to="/faqs">FAQ</Link>
                                    </li>
                                    <li>
                                        <Link to="/contact-us">Contact Us</Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy-policy">Privacy Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/terms-conditions">Terms & Conditions</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer_main_cstm">
                            <div className="ftMenu">
                                <h3 className="font-md text-white">Become a Good Guys Service Provider</h3>
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <Link to="/technician">Technician </Link>
                                    </li>
                                    <li>
                                        <Link to="/existing-company">Existing Company</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="ftMenu">
                                <h3 className="font-md text-white">Become an Affiliate for Good Guys</h3>
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <Link to="/become-a-super-fan">Become a Super Fan </Link>
                                    </li>
                                    <li>
                                        <Link to="/affiliate-login">Become a Referral Partner</Link>
                                    </li>
                                    <li>
                                        <Link to="/affiliate-login">Affiliate Login </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer_main_cstm">
                            {/* <div className="newsLetter">
                                <h3 className="text-white mb-xl-4 mb-2">Newsletter</h3>
                                <div className="newsLetter_field position-relative">
                                    <input type="text" placeholder="Email Address" />
                                    <Button variant="primary">Submit</Button>
                                </div>
                            </div> */}
                            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                                <Link to="/" className="me-2"> <ImageElement className="img-fluid" source="google-play.svg" alt="Google-play"/></Link>
                                <Link to="/"> <ImageElement className="img-fluid" source="app-store.svg" alt="App-store" /> </Link>
                            </div>
                            <div className="joinUs text-center text-sm-start">
                                <h5 className="text-white">Join us on</h5>
                                <ul className="list-inline mb-0">
                                    <li className="list-inline-item">
                                        <Link to="/"><em className="gg-twitter"></em></Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="/"><em className="gg-facebook"></em></Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="/"><em className="gg-linkedin"></em></Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="/"><em className="gg-google"></em></Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="/"><em className="gg-instagram"></em></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_main_bottom">
                <div className="container wrap text-white text-center">
                    © Copyright 2022 Good Guys Home Services
                </div>
            </div>
        </div>
        <div className="chat">
            <Link to="#" className="chat_icon d-flex justify-content-center align-items-center"><em className="gg-chat" /></Link>
        </div>
    </footer>
  );
}
  
export default MainFooter;